<div class="wallet-wrapper" style="margin-left: 250px;">
  <div class="wallet-container">
    <div class="header">
      <h2>Wallet</h2>
      <button *ngIf="accessType !== 4" pButton class="p-button-warning btn-primary" (click)="openDialog()">
        <i class="pi pi-plus" style="vertical-align: middle;"></i>
        <span style="margin-left: 8px;">Add Wallet Balance</span>
      </button>
      <!-- <button *ngIf="accessType !== 4" pButton class="p-button-warning btn-primary" (click)="openDialog()">Add
        balance</button> -->
    </div>

    <div class="balance-card">
      <p>Available balance</p>
      <h2>₹ {{availableBalance|number}}</h2>
    </div>

    <div class="flex justify-content-between flex-wrap align-items-center mb-4">
      <div class="col-2">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input type="text" class="search" pInputText placeholder="Search" [(ngModel)]="searchQuery" (input)="onSearch()" />
        </span>
      </div>

      <div>
        <p-calendar [(ngModel)]="dateRange" selectionMode="range" [showButtonBar]="true" [showIcon]="true"
          [iconDisplay]="'input'" placeholder="Select dates" (ngModelChange)="onDateRangeChanged($event)">
        </p-calendar>
      </div>
    </div>


    <div class="scroll-table-wrapper">
      <p-table [value]="transactions" [paginator]="false" [rows]="pageSize" [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[10, 20, 50]" [lazy]="true" (onLazyLoad)="onPageChange($event)" [scrollable]="false"
        showGridlines>
        <ng-template pTemplate="header">
          <tr>
            <th>Transaction Details</th>
            <!-- <th>Transaction date</th> -->
            <th>Note</th>
            <th>Bank Reference</th>
            <th pSortableColumn="amount">Amount <p-sortIcon field="amount"></p-sortIcon></th>
            <th *ngIf="accessType!==0">Action</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-transaction>
          <tr>
            <!-- <td class="flex" style="flex-direction: column;">
              <div class="flex align-items-center">
                <i [ngClass]="transaction.icon" [style.color]="transaction.color" class="mr-1"></i>
                <span>{{ transaction.details }}</span>
              </div>
              <small style="color: #475467; font-size: 14px; font-weight: 400; margin-left: 3.4rem">{{ transaction.description
                }}</small>
            </td> -->
            <td class="flex align-items-top" style="gap: 12px;"> 
              <div class="flex align-items-center justify-content-center" style="height: 100%;"> 
                <i [ngClass]="transaction.icon" [style.color]="transaction.color"></i>
              </div>
              <div class="flex flex-column"> <!-- Text container -->
                <!-- <span>{{ transaction.details }}</span> -->
                <small >{{ transaction.description }}</small>
                <span style="color: #475467; font-size: 14px; font-weight: 400;">{{ transaction.date }}</span>
              </div>
            </td>
            <!-- <td>{{ transaction.date }}</td> -->
            <!-- <td class="date-time-cell">
              <div class="date">{{ transaction.date }}</div>
              <div class="time">{{ transaction.time }}</div>
          </td> -->
            <td>{{transaction.note}}</td>
            <td>{{ transaction.bankReference || '-' }}</td>
            <td [ngStyle]="{ 'color': transaction.amount.startsWith('-') ? 'red' : 'green' }">
              {{ transaction.amount }}
            </td>
            <td *ngIf="transaction.filePath && accessType!==0; else noAction">
              <i class="pi pi-download cursor-pointer  flex align-items-center "
                (click)="downloadInvoice(transaction.filePath)"> 
              </i>
            </td>
            <ng-template #noAction>
             <!-- <span></span> -->
              <td *ngIf="accessType!==0"></td>
            </ng-template>
          </tr>

        </ng-template>

        <ng-template pTemplate="footer">
          <tr>
            <td colspan="6">
              <div class="flex justify-content-between">
                <div class="flex align-items-center">
                  <div class="footer">Page: {{ pageNumber }} of {{ totalPages }}</div>
                </div>
                <div class="flex justify-content-end">
                  <button type="button" (click)="previousPage()" [disabled]="pageNumber === 1" class="p-paginate mr-2">
                    Previous
                  </button>
                  <button type="button" (click)="nextPage()" [disabled]="pageNumber >= totalPages" class="p-paginate">
                    Next
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
        <!-- Empty state -->
        <!-- <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td colspan="3" class="text-center" style="padding: 20px;">
              <div class="flex align-items-center justify-content-center flex-column">
                <i class="pi pi-info-circle" style="font-size: 2rem; color: #999;"></i>
                <p style="margin-top: 10px; color: #666;">No transactions yet. Add balance or perform an action to view
                  history here.</p>
              </div>
            </td>
          </tr>
        </ng-template> -->
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td colspan="6">
              <div class="empty-state">
                <img src="assets/image/Group.png" alt="No Data" />
                <p class="para1">No Transactions found.</p>
                <p style="margin-top: 10px; color: #666;">No transactions yet. Add balance or perform an action to view
                  history here.</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>


</div>
<app-add-balance *ngIf="displayAddBalance" (close)="displayAddBalance = false"
[calledFrom]="'distributor-wallet-component'" [userId]="userId"
(balanceUpdated)="handleBalanceRefresh()"></app-add-balance>
</div>